import React, { useEffect } from "react";
import Modal from "components/Modal";
import PostPage from "views/Post/PostPage";
import { connect } from "react-redux";
import { togglePostPageModal,toggleProductPageModal } from "stateManagement/reducers/modalReducer";


/**
 * 
 * @param {{post:object,loggedInUser:object,showModal:boolean, deviceSize:string, parentModal:{type:string,parentState:object}}} props
 */
const PostPageModal = (props) => {
    let paramProps = {
        params: {
            post: props.post,
            loggedInUser: props.loggedInUser,
            setPost: props.setPost
        }
    }

    useEffect(() => {
        if (props.showModal) {
            document.querySelector("body").style.overflow = "hidden";
        } else {
            document.querySelector("body").style.overflow = "";
        }
    }, [props.showModal]);

    return (
        <Modal
            isOpen={props.showModal}
            hideOpenAsPage={true}
            toggleModal={() => {

                if (props.parentModal !== null) {
                    switch (props.parentModal?.type) {
                        case "product": {
                            props.toggleProductModal(props.parentModal.parentState, props.loggedInUser, false, null, null);
                            break;
                        }
                        default: {
                            props.toggleModal(props.post, props.loggedInUser, false, props.setPost);
                            break;
                        }
                    }
                }
                else {
                    props.toggleModal(props.post, props.loggedInUser, false, props.setPost)
                }
                
            }}
            showHeader={true}
            showThreeDotMenu={props.loggedInUser ? true : false}
            loggedInUser={props.loggedInUser}
            post={props.post}
            modalDialogCustomClass="modal-dialog-md"
            modalHeaderRedirect={`/Post/PostPage/${props.post?.shareCode}`}
            state={paramProps}
        >
            <PostPage
                match={paramProps}
                isModal={true}
                deviceSize={props.deviceSize}
                loggedInUser={props.loggedInUser}
                isCommenting={props.isCommenting}
                toggleSignUpModal={props.toggleSignUpModal}
            />
        </Modal>   
     )
}

function mapStateToProps(storeState) {
    return {
        showModal: storeState.modalReducer.postPageModal.showPostPageModal,
        shareCode: storeState.modalReducer.postPageModal.shareCode,
        post: storeState.modalReducer.postPageModal.post,
        loggedInUser: storeState.modalReducer.postPageModal.loggedInUser,
        isCommenting: storeState.modalReducer.postPageModal.isCommenting,
        setPost: storeState.modalReducer.postPageModal.setPost,
        parentModal: storeState.modalReducer.postPageModal.parentModal
    }
}

const mapDispatch = {
    toggleModal: togglePostPageModal,
    toggleProductModal: toggleProductPageModal
};

export default connect(mapStateToProps, mapDispatch)(PostPageModal);